import mobileAndShoppingIndex  from '@/views/mobileAndShopping/mobileAndShoppingIndex.vue'

export default {
  path: '/mobileAndShopping',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    {
      path: 'mobileAndShoppingIndex',
      name: 'mobileAndShoppingIndex',
      component: mobileAndShoppingIndex
    },


  ]
}
